import { type UserRole, type UserRoleLabels } from '~entities/users/model/types';

import { normalizeRoleName } from './normalize-role-name';

export const getRoleValue = (
  userRolesData: Array<UserRole> | undefined,
  roleLabel: UserRoleLabels,
): number | undefined => {
  if (!Array.isArray(userRolesData)) {
    return undefined;
  }

  return userRolesData.find(
    (role) => normalizeRoleName(role.name) === normalizeRoleName(roleLabel),
  )?.value;
};
